<template>
  <div class="Gems h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="gem"
      :options="options"
      :options2="options2"
      :func1="this.tier"
      :func2="this.type"
      filter1="Level"
      filter2="Corrupted"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/Two-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Gems",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        "name",
        {
          key: "gemLevel",
          label: "Level",
          sortable: true,
        },
        {
          key: "gemIsCorrupted",
          label: "Corrupted?",
        },
        {
          key: "gemQuality",
          label: "Quality",
        },
        {
          key: "change",
          tdClass: "text-nowrap",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "1", value: "1", disabled: false },
        { text: "2", value: "2", disabled: false },
        { text: "3", value: "3", disabled: false },
        { text: "4", value: "4", disabled: false },
        { text: "5", value: "5", disabled: false },
        { text: "6", value: "6", disabled: false },
        { text: "7", value: "7", disabled: false },
        { text: "20", value: "20", disabled: false },
        { text: "21", value: "21", disabled: false },
      ],
      options2: [
        { text: "All", value: "All", disabled: false },
        { text: "Yes", value: "Yes", disabled: false },
        { text: "No", value: "No", disabled: false },
      ],
    };
  },
  mounted() {},

  methods: {
    getHref(item) {
      if (item.name != undefined) {
        let gemAlternateQuals = ["Phantasmal", "Anomalous", "Divergent"];
        if (gemAlternateQuals.some((v) => item.name.includes(v))) {
          return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"term":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"quality":{"min":${item.gemQuality},"max":${item.gemQuality}},"corrupted":{"option":"${item.gemIsCorrupted}"},"gem_level":{"min":${item.gemLevel},"max":${item.gemLevel}}},"disabled":false}}},"sort":{"price":"asc"}}`;
        }
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"quality":{"min":${item.gemQuality},"max":${item.gemQuality}},"corrupted":{"option":"${item.gemIsCorrupted}"},"gem_level":{"min":${item.gemLevel},"max":${item.gemLevel}}},"disabled":false}}},"sort":{"price":"asc"}}`;
      }
    },
    type(val, item) {
      if (val == "Yes" && item.gemIsCorrupted) {
        return true;
      }
      if (val == "No" && !item.gemIsCorrupted) {
        return true;
      }
      return false;
    },
    tier(val, item) {
      // != "All"
      if (item.gemLevel == val) {
        return true;
      }
      return false;
    },
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss"></style>
